import React from 'react';
import { CardNumberElement } from '@stripe/react-stripe-js';
import { IPayments } from 'interfaces/payment';

const CardNumber: React.SFC<IPayments.ICardElementProp> = props => {
  return (
    <div className='form-group'>
      <label>Card Number Details</label>
      <div className='form-control' id='card-number-element'>
        <CardNumberElement
          options={props.styles}
        />
      </div>
    </div>
  );
};

export default CardNumber;
